import { Component, ElementRef, OnInit } from '@angular/core';

const BUTTON_ATTRIBUTES: string[] = [
  'normal-button',
  'normal-big-button',
  'normal-outline-button',
  'outline-button',
  'big-outline-icon-button',
  'icon-button',
  'submit-button',
  'small-button',
  'text-button',
  'small-icon-button',
  'outline-icon-button',
  'action-button',
  'incentive-button',
];
@Component({
    selector: 'gl-button, button[normal-button], button[normal-big-button], button[normal-outline-button], button[outline-button], button[icon-button], button[submit-button],button[incentive-button], button[small-button], button[text-button], button[small-icon-button], button[action-button], button[outline-icon-button],  button[big-outline-icon-button]',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent implements OnInit {
  constructor(private el: ElementRef<HTMLElement>) {}

  public ngOnInit(): void {
    BUTTON_ATTRIBUTES.forEach((attr) => {
      if (this.hasAttribute(attr)) {
        this.el.nativeElement.classList.add(attr);
      }
    });
  }

  private hasAttribute(attribute: string) {
    return this.el.nativeElement.hasAttribute(attribute);
  }
}
